import * as React from 'react';
import { Box, BoxStyle } from '../../components/Box';
import Section from '../../components/Section';
import { Guide, getDose } from '../../guide';

type Props = {
  guide: Guide;
};

export default function DoseSection(props: Props) {
  return (
    <Section title="Prepare" bodyStyle={BoxStyle.Padded}>
      <div className="flex-ns justify-center">
        <div className="pr3 tc mb3">
          <div
            className={
              'br-100 w3 h3 h4-ns w4-ns tc gold bg-ui-black-3 f4 flex flex-column justify-center'
            }
          >
            {props.guide.grind_size}
          </div>
          <h4 className="lh-copy ma0 mt3 f6 black-50 ttu">GRIND SIZE</h4>
        </div>
        <div className="ph3 tc mb3">
          <div
            className={
              'br-100 w3 h3 h4-ns w4-ns tc gold bg-ui-black-3 f4 flex flex-column justify-center'
            }
          >
            {getDose(props.guide).coffee}g
          </div>
          <h4 className="lh-copy ma0 mt3 f6 black-50 ttu">COFFEE</h4>
        </div>
        <div className="pl3 tc mb3">
          <div
            className={
              'br-100 w3 h3 h4-ns w4-ns tc gold bg-ui-black-3 f4 flex flex-column justify-center'
            }
          >
            {getDose(props.guide).water}ml
          </div>
          <h4 className="lh-copy ma0 mt3 f6 black-50 ttu">
            WATER ({props.guide.temperature}°C)
          </h4>
        </div>
      </div>
    </Section>
  );
}
